"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _inputHOC = _interopRequireDefault(require("../Form/inputHOC"));
var _withMask = _interopRequireDefault(require("../TextInput/withMask"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _StyledIbanInput = require("./StyledIbanInput");
var _excluded = ["customFormItem", "mask"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var ibanMask = ['T', 'R', /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /[A-Z0-9]/i, /[A-Z0-9]/i, ' ', /[A-Z0-9]/i, /[A-Z0-9]/i, /[A-Z0-9]/i, /[A-Z0-9]/i, ' ', /[A-Z0-9]/i, /[A-Z0-9]/i, /[A-Z0-9]/i, /[A-Z0-9]/i, ' ', /[A-Z0-9]/i, /[A-Z0-9]/i, /[A-Z0-9]/i, /[A-Z0-9]/i, ' ', /[A-Z0-9]/i, /[A-Z0-9]/i];
var maskHoc = (0, _withMask.default)(_StyledIbanInput.StyledIbanInput);
var MaskedInput = (0, _inputHOC.default)(maskHoc);
maskHoc.displayName = 'IbanInput';
var IbanInput = /*#__PURE__*/function (_Component) {
  function IbanInput() {
    var _this;
    (0, _classCallCheck2.default)(this, IbanInput);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, IbanInput, [].concat(args));
    (0, _defineProperty2.default)(_this, "handleChange", function (e, unMaskedValue, maskedValue) {
      if (_this.props.onChange) _this.props.onChange(e, unMaskedValue, maskedValue);
    });
    (0, _defineProperty2.default)(_this, "unMask", function (maskedValue) {
      return maskedValue.replace(/\_/g, '').replace(/\s/g, '');
    });
    return _this;
  }
  (0, _inherits2.default)(IbanInput, _Component);
  return (0, _createClass2.default)(IbanInput, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        customFormItem = _this$props.customFormItem,
        mask = _this$props.mask,
        props = (0, _objectWithoutProperties2.default)(_this$props, _excluded);
      return /*#__PURE__*/_react.default.createElement(MaskedInput, (0, _extends2.default)({}, props, {
        guide: true,
        unMask: this.unMask,
        mask: mask || ibanMask,
        onChange: this.handleChange
      }));
    }
  }]);
}(_react.Component);
IbanInput.displayName = 'IbanInput';
IbanInput.propTypes = {
  customFormItem: _propTypes.default.bool,
  mask: _propTypes.default.array,
  placeholder: _propTypes.default.string
};
IbanInput.defaultProps = {
  customFormItem: true,
  mask: null,
  placeholder: 'TR77 0000 0000 0000 0000 0000 00'
};
var _default = exports.default = IbanInput;